import React from 'react'

import { createStyles, Theme, Typography } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

const SectionHeader: React.SFC<SectionHeaderProps & WithStyles<typeof styles>> = ({ classes, text, subHeader }) => {
  return (
    <Typography variant={subHeader ? 'subtitle1' : 'h6'} paragraph className={classes.header}>
      {text}
    </Typography>
  )
}

export type SectionHeaderProps = {
  text: string
  subHeader?: boolean
}

const styles = ({ spacing }: Theme) =>
  createStyles({
    header: {
      marginBottom: spacing(),
    },
  })

export default withStyles(styles)(SectionHeader)
